import { useMemo } from "react"

import zenginCode from "zengin-code"

type BankLookupResult = {
	bankName: string | null
	branchName: string | null
}

/**
 * 銀行コード・支店コードから銀行名・支店名をルックアップする hooks。
 * zengin-code パッケージを使用して FE 内で完結する。
 */
export const useBankLookup = (
	bankCode: string,
	branchCode: string
): BankLookupResult => {
	const bankName = useMemo(() => {
		if (!bankCode || !/^\d{4}$/.test(bankCode)) return null
		const bank = zenginCode[bankCode]
		// null: 未入力/不正形式, "": 該当なし, string: 銀行名
		return bank?.name ?? ""
	}, [bankCode])

	const branchName = useMemo(() => {
		if (
			!bankCode ||
			!/^\d{4}$/.test(bankCode) ||
			!branchCode ||
			!/^\d{3}$/.test(branchCode)
		)
			return null
		const bank = zenginCode[bankCode]
		if (!bank) return null
		const branch = bank.branches[branchCode]
		// null: 未入力/不正形式, "": 該当なし, string: 支店名
		return branch?.name ?? ""
	}, [bankCode, branchCode])

	return { bankName, branchName }
}
